module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j1qWE"))).then(() => parcelRequire('hEqeo'));